import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClientsSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48.698,
	height: 53.824,
	viewBox: "0 0 48.698 53.824",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "clients",
		transform: "translate(-1122.5 -219.967)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_11343",
			"data-name": "Group 11343",
			transform: "translate(1123 220.467)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_68803",
					"data-name": "Path 68803",
					d: "M1532.829-73.954a12.009,12.009,0,0,1,11.733-12.022,12,12,0,0,1,12.247,11.857,12.04,12.04,0,0,1-11.943,12.182A12.045,12.045,0,0,1,1532.829-73.954Zm11.965,8.979a9.034,9.034,0,0,0,9.038-8.862A9.1,9.1,0,0,0,1544.844-83a9.11,9.11,0,0,0-9.037,9.039A9.03,9.03,0,0,0,1544.794-64.975Z",
					transform: "translate(-1520.776 85.977)",
					fill: "#fff",
					stroke: "#fff",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_68804",
					"data-name": "Path 68804",
					d: "M1651.052,164.408a10.114,10.114,0,0,1-1.118-.358c-1.217-.544-2.414-1.134-3.638-1.661a1.1,1.1,0,0,0-.828.026c-.937.479-1.833,1.037-2.763,1.531a2.784,2.784,0,0,1-3.115.025,3.01,3.01,0,0,1-1.332-3.235c.2-1.01.354-2.028.573-3.033a1.212,1.212,0,0,0-.424-1.348c-.753-.633-1.452-1.331-2.16-2.016a2.975,2.975,0,0,1-.856-3.209,2.713,2.713,0,0,1,2.475-1.882c1.16-.15,2.317-.331,3.465-.555a1.164,1.164,0,0,0,.705-.521c.562-1.025,1.074-2.079,1.587-3.131a2.8,2.8,0,0,1,5.091-.006c.527,1.07,1.048,2.143,1.617,3.19a1.081,1.081,0,0,0,.667.471c1.125.22,2.26.387,3.393.563a2.854,2.854,0,0,1,2.422,1.991,2.905,2.905,0,0,1-.805,3.037c-.808.818-1.641,1.611-2.425,2.451a1.051,1.051,0,0,0-.237.772c.177,1.179.455,2.344.618,3.524A2.961,2.961,0,0,1,1651.052,164.408Zm-.236-2.849c-.23-1.19-.411-2.269-.652-3.335a3.173,3.173,0,0,1,.979-3.308c.895-.815,1.723-1.7,2.679-2.654-1.128-.171-2.108-.354-3.1-.461a3.642,3.642,0,0,1-3.315-2.31c-.217-.54-.52-1.046-.786-1.566-.239-.468-.48-.935-.767-1.494-.453.995-.907,1.845-1.234,2.742a3.752,3.752,0,0,1-3.658,2.646c-.975.055-1.94.287-3.029.457.984.888,1.826,1.705,2.729,2.45a3.04,3.04,0,0,1,1.078,3.2c-.233,1.165-.434,2.337-.671,3.625,1.036-.576,2-1.047,2.893-1.624a3.27,3.27,0,0,1,3.752-.058C1648.695,160.451,1649.716,160.962,1650.816,161.558Z",
					transform: "translate(-1608.759 -111.115)",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_68805",
					"data-name": "Path 68805",
					d: "M1447.224,128.822a23.9,23.9,0,0,1,7.483-16.119,23.41,23.41,0,0,1,14.345-6.548,23.808,23.808,0,0,1,11.484,1.683c.651.268,1.147.626,1.179,1.4a1.438,1.438,0,0,1-1.976,1.465c-1.593-.457-3.17-1.01-4.793-1.306a20.141,20.141,0,0,0-15.451,3.284,20.708,20.708,0,0,0-9.021,14.242c-.166.988-.148,2.007-.218,3.012-.067.966-.5,1.5-1.273,1.585a1.435,1.435,0,0,1-1.755-1.507C1447.207,129.62,1447.224,129.221,1447.224,128.822Z",
					transform: "translate(-1447.217 -79.007)",
					fill: "#fff",
					stroke: "#fff",
					strokeWidth: 1
				})
			]
		})
	})
});
export default SvgClientsSettings;
